import {JwtHelperService} from '@auth0/angular-jwt';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { EcaSecurityService, ApiGatewayService, AppContextService } from '@drc-eca/eca-components-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalSecurityService } from '../../services/shared/local-security.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatCard } from '@angular/material/card';

import { MatInput } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'eca-login',
    templateUrl: './eca-login.component.html',
    styleUrls: ['./eca-login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCheckbox, MatLabel, MatFormField, MatFormFieldModule, MatCard, MatInput, MatButtonModule, FormsModule]

})
export class EcaLoginComponent implements OnInit {
  private securityService = inject(EcaSecurityService);
  private locaSecuritySvc = inject(LocalSecurityService);
  private apiGatewayService = inject(ApiGatewayService);
  private appContextService = inject(AppContextService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  
  userEmail: string;
  userPassword: string;
  passInputType: string = 'password';
  errorMsg: string = '';
  hasError: boolean = false;
  isAuthenticated: boolean = false;
  loginFailed: boolean = false;
  capslock: boolean = false;
  localSecurityOn: boolean = false;

  constructor() {
    this.passInputType = 'password';
  }

  ngOnInit() {

    this.appContextService.setToken(null);

    // set caps lock warning to off in Egde and IE, since we display our own warning
    (document as any).msCapsLockWarningOff = true;

    document.addEventListener('keydown', event => {
      this.capslock = event.getModifierState && event.getModifierState('CapsLock');
    });
  }

  togglePasswordText() {
    if (this.passInputType === 'password') {
      this.passInputType = 'text';
    } else {
      this.passInputType = 'password';
    }
  }

  togglePortalLogin = () =>{
    this.localSecurityOn = this.localSecurityOn ? false : true;
  }

  login() {
    this.loginFailed = false;
    if(!this.localSecurityOn){
      this.securityService.authenticateCredentials(this.userEmail, this.userPassword).subscribe({
        next: () => {
          this.loginSuccess();          
        },
        error: (error: any) => { this.loginError(error)}
      });
    }else{
      this.locaSecuritySvc.authenticate(this.userEmail, this.userPassword).subscribe({
        next: user => { 
          this.appContextService.setToken(user['token']);
          this.appContextService.setUserId(user['userId']);
          this.apiGatewayService.userToken = user['token'];          
          this.loginSuccess();          
        },
        error: (error: any) => this.loginError(error)
      });
    }
    
  }

  private loginSuccess() {
    this.apiGatewayService.clearCache();
    this.isAuthenticated = true;
    sessionStorage.setItem('isAuthenticated', 'true');
    sessionStorage.setItem('localSecurityOn', String(this.localSecurityOn));
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.parseToken();
    if (returnUrl) {
      this.router.navigate(['/status/update/services'], { queryParams: { returnUrl: returnUrl }});
    } else {
      this.router.navigate(['/status/update/services']);
    }
  }

  private loginError(error) {
    this.loginFailed = true;
    sessionStorage.setItem('isAuthenticated', 'false');
    switch (error.status) {
      case 404: {
        this.showError('404: Security Serivce Not Found');
      }
    }

    // For now, ANY error should result in error message
    this.showError('Request to login failed.');
  }

  private showError(msg: string = '') {
    if (msg) {
      this.errorMsg = msg;
    }
    this.hasError = true;
  }

  parseToken(){
    this.appContextService.getToken().subscribe( token => {
      if (token && token !== ''){
        const helper = new JwtHelperService(); 
        const decodedToken = helper.decodeToken(token);
        sessionStorage.setItem('ngStorage-ecausername', decodedToken['username']);
      }
    });
  }

}
